// extracted by mini-css-extract-plugin
export default {"package_list_title":"userPackages_package_list_title__gIa2N","package_title-text":"userPackages_package_title-text__woocO","ref-link":"userPackages_ref-link__2+uNK"};